export default __webpack_public_path__ + "static/media/visa.68f269bb.jpg";